/**
 * Lalay profile API — wraps /wp-json/lalay/v1/me + /me/avatar.
 */

import { getToken } from './auth';

const BASE = '/wp-json/lalay/v1';

export async function updateProfile(payload) {
  const tok = getToken();
  if (!tok) return { error: 'Not signed in' };
  const res = await fetch(`${BASE}/me`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${tok}`,
    },
    body: JSON.stringify(payload),
  });
  const body = await res.json().catch(() => null);
  if (res.ok && body?.success) return { user: body.user };
  return { error: body?.message || 'Could not save profile', code: body?.code, status: res.status };
}

export async function uploadAvatar(file) {
  const tok = getToken();
  if (!tok) return { error: 'Not signed in' };
  const form = new FormData();
  form.append('file', file);
  const res = await fetch(`${BASE}/me/avatar`, {
    method: 'POST',
    headers: { Authorization: `Bearer ${tok}` }, // browser sets multipart boundary
    body: form,
  });
  const body = await res.json().catch(() => null);
  if (res.ok && body?.success) return { profileImage: body.profileImage };
  return { error: body?.message || 'Upload failed', code: body?.code, status: res.status };
}

export async function changePassword({ currentPassword, newPassword }) {
  const tok = getToken();
  if (!tok) return { error: 'Not signed in' };
  const res = await fetch(`${BASE}/me/change-password`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${tok}`,
    },
    body: JSON.stringify({ currentPassword, newPassword }),
  });
  const body = await res.json().catch(() => null);
  if (res.ok && body?.success) return { ok: true };
  return { error: body?.message || 'Could not change password', code: body?.code, status: res.status };
}
